var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"grid_flex mb-2"},[_c('div',{staticClass:"d-flex justify-center align-center"},[_c('div',{staticClass:"img_title_header ma-2"},[_c('img',{attrs:{"src":_vm.$props.img_header}})]),_c('h2',{staticClass:"title_header"},[_vm._v(_vm._s(_vm.$props.header))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }